__turbopack_context__.v({
  "active": "_BoQMW_active",
  "close": "_BoQMW_close",
  "dialog": "_BoQMW_dialog",
  "dropdown": "_BoQMW_dropdown",
  "dropdown-item": "_BoQMW_dropdown-item",
  "environments": "_BoQMW_environments",
  "item": "_BoQMW_item",
  "languages": "_BoQMW_languages",
  "logo": "_BoQMW_logo",
  "main-item-list": "_BoQMW_main-item-list",
  "main-item-wrapper": "_BoQMW_main-item-wrapper",
  "my-bolt": "_BoQMW_my-bolt",
  "shape": "_BoQMW_shape",
  "small-bar": "_BoQMW_small-bar",
});
